import React from "react";
import { motion } from "framer-motion";
import { CheckCircle2, XCircle, Sparkles } from "lucide-react";

export default function ResultReveal({ result, question, myId }) {
  const mine = result.player_results[myId];
  return (
    <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="glass-panel rounded-2xl p-6" data-testid="duel-result-reveal">
      <div className="flex items-center gap-2 mb-3">
        {mine?.correct ? <CheckCircle2 className="w-5 h-5 text-emerald-400" /> : <XCircle className="w-5 h-5 text-red-400" />}
        <span className="text-sm font-bold text-white" data-testid="duel-result-outcome">
          {mine?.correct ? `Correct! +${mine.points} pts` : "Incorrect"}
        </span>
      </div>
      <p className="text-sm text-slate-300 mb-3">
        <span className="font-semibold text-emerald-300">Correct answer:</span> {question.options[result.correct_index]}
      </p>
      <div className="rounded-lg border border-indigo-400/20 bg-indigo-400/5 p-3">
        <span className="flex items-center gap-1 text-[10px] font-bold uppercase text-indigo-400 mb-1"><Sparkles className="w-3 h-3" /> AI Explanation</span>
        <p className="text-sm text-slate-300" data-testid="duel-result-explanation">{result.explanation}</p>
        {result.best_practice && <p className="text-xs text-slate-400 mt-2 pt-2 border-t border-white/5">{result.best_practice}</p>}
      </div>
    </motion.div>
  );
}
